import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-navy-mid px-5 py-10 sm:py-16" data-id="element-88" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-gold/45 bg-navy p-6 text-center sm:p-12" data-id="element-89" data-mp="222wi64l3xum1">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-90" data-mp="1j4ty847f2nv3">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-91" data-mp="1edkdni0q6aq2" />
        </span>
        <h2 className="mt-5 font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-92" data-mp="qnpygtsxoa2n">
          14-Day Money-Back Guarantee
        </h2>
        <p className="mt-2 text-sm font-medium text-gold sm:text-base" data-id="element-93" data-mp="loda24meyuxy">
          Take the time to see how it fits your classes.
        </p>
        <div className="mt-5 space-y-3 text-sm leading-relaxed text-white/75 sm:space-y-4 sm:text-base" data-id="element-94" data-mp="tymi48vjfoz8">
          <p data-id="element-95" data-mp="ypbcbvylr022">
            Take a look through THE COMPLETE ART YEAR™ and see how the resources fit your classes.
            If you decide it isn&apos;t the right fit, contact us within the guarantee period and
            follow the refund terms provided with your purchase.
          </p>
          <p data-id="element-96" data-mp="6306o6w528ye">
            The six core volumes and five professional bonuses are yours to review in full during
            that period.
          </p>
          <p className="font-semibold italic text-white" data-id="element-97" data-mp="f0kclt4y4tfc">
            You decide whether the system belongs in your classroom.
          </p>
        </div>
        <div className="mt-6 w-full max-w-md sm:mt-8" data-id="element-98" data-mp="1qgir4ciw87ny">
          <CTAButton label="GET THE COMPLETE ART YEAR™" data-id="element-99" data-mp="1qfz8etlf5f8v" />
          <p className="mt-3 text-xs text-white/60 sm:text-sm" data-id="element-100" data-mp="1vf2emhd4xrif">
            One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
          </p>
        </div>
      </motion.div>
    </section>;
}